import { FC } from "react";
import { Button, createStyles, makeStyles } from "@material-ui/core";
import { FilterList as FilterListIcon } from "@material-ui/icons";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    filterListButton: {
      color: theme.custom.palette.purple.main,
      fontWeight: theme.typography.fontWeightLight,
      padding: 0,
      "&:hover": {
        backgroundColor: theme.custom.palette.purple.light,
      },
    },
  }),
);

const FilterButton: FC<{ label: string; onClick: () => void }> = ({
  label,
  onClick,
}) => {
  const classes = useStyles();
  return (
    <Button className={classes.filterListButton} onClick={onClick}>
      <FilterListIcon />
      &nbsp;&nbsp;{label}
    </Button>
  );
};

export default FilterButton;
